import { useEffect, useState } from "react";
import ModalElement from "../../../Common/ModalElement";
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import SearchDropdown from "../../../Common/SearchDropdown";
import MultiSelectDropdown from "../../../Common/MultiChoiceElement";
import { validateFields, commonOnChange } from "../../../utils";
import { taskManagementApi } from "../../../actions/taskManagement";
import { useApiRequest } from "../../../hooks/useApiRequest";

// Priority options matching backend enum
const priorityOptions = [
    { id: "Low", name: "Low" },
    { id: "Medium", name: "Medium" },
    { id: "High", name: "High" },
];

const AddTicket = ({ show, hideModal, successAction, ccMemberOptions = [] }) => {
    const { request, loading: apiLoading } = useApiRequest();

    const [state, setState] = useState({
        title: "",
        description: "",
        priority: "Medium",
        assignee_id: null,
        assigneeName: "",
        ccMembers: [],
        dueDate: "",
        titleErr: null,
        descriptionErr: null,
        assignee_idErr: null,
        priorityErr: null,
        loading: false,
        assigneeOptions: []
    });

    const { title, description, priority, assignee_id, assigneeName, ccMembers, dueDate, titleErr, descriptionErr, loading, priorityErr, assignee_idErr } = state;
    const onChangeHandler = (event) => commonOnChange(event, setState);

    const submit = async () => {
        validateFields(
            {
                titleErr: [title, "text"],
                descriptionErr: [description, "text"],
                priorityErr: [priority, "text"],
                assignee_idErr: [assignee_id, "number"]
            },
            setState,
            async () => {
                setState(prev => ({ ...prev, loading: true }));

                // Prepare task data for backend
                const taskData = {
                    title,
                    description,
                    priority,
                    assignee_id,
                    due_date: dueDate || null,
                    ccMembers: ccMembers?.map(member => member?.userId) || []
                };

                // Create task using useApiRequest
                await request({
                    method: "POST",
                    url: taskManagementApi.createTask,
                    body: taskData,
                    showToast: true,
                    onSuccess: () => {
                        successAction();
                        setTimeout(hideModal, 1000);
                    }
                });
            }
        );
    }

    // Use ccMemberOptions passed from parent component
    useEffect(() => {
        if (ccMemberOptions?.length > 0) {
            setState(prev => ({
                ...prev,
                assigneeOptions: ccMemberOptions
            }));
        }
    }, [ccMemberOptions]);

    return (
        <ModalElement
            show={show}
            onHide={hideModal}
            title="Create Task"
            size="lg"
            FooterComponent={
                <div className="d-flex justify-content-end gap-2">
                    <ButtonElement
                        text="Cancel"
                        cssClass="small-radius"
                        onClick={hideModal}
                        variant="btn-outline-grey"
                        disabled={apiLoading || loading}
                    />
                    <ButtonElement
                        text={apiLoading || loading ? "Creating..." : "Create Task"}
                        cssClass="small-radius"
                        onClick={submit}
                        variant="btn-primary"
                    // disabled={apiLoading || loading}
                    />
                </div>
            }
        >
            <div className="create-task-form text-start">
                {/* Title Field */}
                <div className="form-group mb-3">
                    <InputElement
                        label={"Title"}
                        type="text"
                        placeholder="Enter task title..."
                        name="title"
                        value={title}
                        onChange={onChangeHandler}
                        error={titleErr}
                        disable={apiLoading || loading}
                    />
                </div>

                {/* Description Field */}
                <div className="form-group mb-3">
                    <InputElement
                        label={"Description"}
                        type="text"
                        placeholder="Enter task description..."
                        name="description"
                        value={description}
                        onChange={onChangeHandler}
                        error={descriptionErr}
                        isTextArea={true}
                        textRows="4"
                        disable={apiLoading || loading}
                    />
                </div>

                {/* Priority and Status Row */}
                <div className="row mb-3">
                    <div className="col-md-6">
                        <SearchDropdown
                            label="Priority"
                            placeholder="Select priority"
                            value={priority}
                            onSelect={(selected) => {
                                setState(prev => ({
                                    ...prev,
                                    priority: selected ? selected.name : "Medium",
                                    priorityErr: null
                                }));
                            }}
                            error={priorityErr}
                            options={priorityOptions}
                        />
                    </div>
                    <div className="col-md-6">
                        <SearchDropdown
                            label="Assignee"
                            placeholder="Select an assignee"
                            value={assigneeName}
                            onSelect={(selected) => {
                                setState(prev => ({
                                    ...prev,
                                    assignee_id: selected?.id || "",
                                    assigneeName: selected?.name || "",
                                    assignee_idErr: null
                                }));
                            }}
                            error={assignee_idErr}
                            options={state.assigneeOptions}
                        />
                    </div>
                </div>

                {/* CC Members - Multi-select dropdown */}
                <div className="form-group mb-3 mt-2">
                    <MultiSelectDropdown
                        label="CC Members"
                        placeholder="Select CC members"
                        options={state.assigneeOptions}
                        values={ccMembers}
                        onSelect={(selectedMembers) => setState(prev => ({ ...prev, ccMembers: selectedMembers }))}
                        disabled={apiLoading || loading}
                        isRequired={false}
                    />
                </div>

                <div className="col-md-12">
                    <InputElement
                        label={"Due Date"}
                        type="date"
                        placeholder="Pick a date"
                        name="dueDate"
                        value={dueDate}
                        onChange={onChangeHandler}
                        disable={apiLoading || loading}
                        isRequired={false}
                    />
                </div>


            </div>
        </ModalElement>
    );
};

export default AddTicket;